import { EMPTY_COMMUNICATION_PREFERENCES } from '@nx-ng/constants';
import {
  BookingSummaryItem,
  CustomerTypeIds,
  ICommunicationPreferences,
} from '@nx-ng/types';

export const configureCommunicationPreferences = (
  items: BookingSummaryItem[] = []
): ICommunicationPreferences => {
  return {
    ...EMPTY_COMMUNICATION_PREFERENCES,
    showGuardianConsent: hasChildTickets(items),
  };
};

export const hasChildTickets = (items: BookingSummaryItem[] = []): boolean => {
  return items.some(
    (item: BookingSummaryItem) => item.customerType === CustomerTypeIds.Child
  );
};
